<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' @child-event='getNumVal' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>

		</div>


		<Button class="submit-process" v-on:click='submit' v-bind:disabled="isDisabled" v-bind:loading="formLoading" size="large"
		 type="primary"> 提交 </Button>
	</div>
</template>



<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import Choose from '../components/Choose.vue';
	import wx from 'weixin-js-sdk'

	import stringUtils from "../assets/js/stringUtil.js";

	import {
		getTemplateInfo,
		submitProcess
	} from '@/api/approval'
	import {
		getRelation,
		getUserInfo
	} from '@/api/employee'
	import {
		initWxConfig
	} from "../api/jssdk.js";
	var isSubmit = false;
	var employees = null;
	var deptName = null;
	var code = null;
	var template = {
		TemplateContent: {
			Controls: []
		}
	};

	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
			Choose
		},
		data() {
			return {
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null,
				listLoading: false,
				isDisabled: false,
				formLoading: false
			}
		},
		created() {
			initWxConfig(this);
			this.logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.spNo = this.$route.query.spNo;
			this.getTemplate();
			stringUtils.setAddIsShow(false);
		},
		methods: { //方法
			clickChoose: async function(dataVal, name) {
				var that = this;
				window.wx.invoke("selectEnterpriseContact", {
					"fromDepartmentId": 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
					"mode": "single", // 必填，选择模式，single表示单选，multi表示多选
					"type": ["user"], // 必填，选择限制类型，指定department、user中的一个或者多个
					"selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
					"selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				}, async function(res) {
					if (res.err_msg == "selectEnterpriseContact:ok") {
						if (typeof res.result == 'string') {
							res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
						}
						var user = res.result.userList[0];
						dataVal.Values = [];

						var deptFullName = null;
						var jobLevel = null;
						var dataName = null;
						await getUserInfo(user.id).then(response => {
							employees = response.Body.EmployeeInfo;
						});
						
						deptFullName = employees.fullName.split("/");
						jobLevel = employees.JobLevel;
						
						
						if (deptFullName.indexOf("非营业部") > -1) {
							if (jobLevel >= 5) {
								dataVal.Values = [];
								dataVal.Value = user.name;
								dataVal.Values.push([user.id, user.name]);
							} else {
								dataVal.Value = '';
								dataVal.Values = [];
							}
						} else{
							if (jobLevel >= 6) {
								dataVal.Values = [];
								dataVal.Value = user.name;
								dataVal.Values.push([user.id, user.name]);
							} else {
								dataVal.Value = '';
								dataVal.Values = [];
							}
						}
						
						if(dataVal.Values!=null&&dataVal.Values.length>0){
							that.templateData.TemplateContent.Controls.forEach((item, index) => {
								if (item.Property.Title[0].Text == "部门 ") {
									if (employees != null && employees.DeptName != null) {
										if (deptFullName.indexOf("华西区") > -1) {
											item.Value = deptFullName[deptFullName.indexOf("华西区") + 1] + "/" + deptFullName[deptFullName.length -
												1];
										}
										if (deptFullName.indexOf("非营业部") > -1) {
											item.Value = deptFullName[deptFullName.indexOf("非营业部") + 1] + "/" + deptFullName[deptFullName.length -
												1];
										}
										if (deptFullName.indexOf("营业部") > -1) {
											item.Value = deptFullName[deptFullName.indexOf("营业部") + 1] + "/" + deptFullName[deptFullName.length -
												1];
										}
										if (deptFullName.indexOf("其他") > -1) {
											item.Value = deptFullName[deptFullName.indexOf("其他") + 1] + "/" + deptFullName[deptFullName.length - 1];
										}
									}
									item.IsShow = true;
							
								}else if(item.Property.Title[0].Text == "工号"){
									item.IsShow = true;
									item.Value = user.id;
								}
								
							})
						}
						
						if (dataVal.Value == null || dataVal.Value.length <= 0) {
							that.Message({
								message: "该人员没有申请权限，请重新选择",
								type: "warning",
								duration: 3 * 1000
							});
							dataName = that.logInfo.EmpName;
						}
					}

				})
			},
			getTemplate: async function() {
				this.listLoading = true;
				var title = this.logInfo.fullName;
				var departs = this.logInfo.fullName.split("/");
				var jobLevel = this.logInfo.JobLevel;

				// if (departs.indexOf("非营业部") > -1) {
				// 	if (jobLevel < 5) {
				// 		this.isDisabled = true;
				// 		this.Message({
				// 			message: "没有申请权限",
				// 			type: "error",
				// 			duration: 3 * 1000
				// 		})
				// 	}
				// } else {
				// 	if (jobLevel < 6) {
				// 		this.isDisabled = true;
				// 		this.Message({
				// 			message: "没有申请权限",
				// 			type: "error",
				// 			duration: 3 * 1000
				// 		})
				// 	}


				// }
				await this.getEmployeeRelation(this.logInfo.EmpNo);
				getTemplateInfo(this.templateId).then(async response => {
					var controls = response.Body;
					controls.TemplateContent.Controls.forEach(async (item) => {
						item.IsShow = false;
						if (item.Property.Title[0].Text == "申请人") {
							item.Value = this.logInfo.EmpName;
							item.IsShow = true;
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "借支类型") {
							if (departs.indexOf("非营业部") == -1) {
								//营业部
								var option = item.Config.Selector.Options.filter(t => {
									return t.Value[0].Text == "非营业借支"
								})[0];
								item.Config.Selector.Options.splice(option, 1);
							}
						}
						if (item.Property.Title[0].Text == "逐级审批使用") {
							item.Values = [];
							item.Values = this.getRelationList(this.relationList, 8);
							if (item.Values == null || item.Values.length <= 0) {
								//审批节点无人，跳过
								item.Values.push(this.$store.state.defaultMember);
							}
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "部门负责人") {
							item.Values = [];
							item.Values = this.findEmpByLevel(this.relationList, 8);
							if (item.Values == null || item.Values.length <= 0) {
								//审批节点无人，跳过
								item.Values.push(this.$store.state.defaultMember);
							}
							item.IsShow = false;
						}

						if (item.Property.Title[0].Text == "人员") {
							item.IsShow = true;
						}
						if (item.Property.Title[0].Text == "借支人员") {
							item.IsShow = true;
							item.Disable = false;
							if (departs.indexOf("非营业部") > -1) {
								if (jobLevel >= 5) {
									item.Value = this.logInfo.EmpName;
									item.Values = [
										[this.logInfo.EmpNo, this.logInfo.EmpName]
									]
								} else {
									item.Value = '';
									item.Values = []
								}
							} else if (departs.indexOf("营业部") > -1) {
								if (jobLevel >= 6) {
									item.Value = this.logInfo.EmpName;
									item.Values = [
										[this.logInfo.EmpNo, this.logInfo.EmpName]
									]
								} else {
									item.Value = '';
									item.Values = []
								}
							}

						}
						if (item.Property.Title[0].Text == "工号") {
							item.IsShow = true;
						}
						if (item.Property.Title[0].Text == "借支类型") {
							item.IsShow = true;
						}
						if (item.Property.Title[0].Text == "付款公司") {
							item.IsShow = true;
						}

						if (item.Property.Title[0].Text == "部门 ") {
							if (departs.indexOf("华西区") > -1) {
								item.Value = departs[departs.indexOf("华西区") + 1] + "/" + this.logInfo.DeptName;
							}
							if (departs.indexOf("非营业部") > -1) {
								item.Value = departs[departs.indexOf("非营业部") + 1] + "/" + this.logInfo.DeptName;
							}
							if (departs.indexOf("营业部") > -1) {
								item.Value = departs[departs.indexOf("营业部") + 1] + "/" + this.logInfo.DeptName;
							}
							if (departs.indexOf("其他") > -1) {
								item.Value = departs[departs.indexOf("其他") + 1] + "/" + this.logInfo.DeptName;
							}
							item.IsShow = true;

						}
						if (item.Property.Title[0].Text == "借支事由") {
							item.IsShow = true;
						}
						if (item.Property.Title[0].Text == "借款类型") {
							item.IsShow = true;
						}
						if (item.Property.Title[0].Text == "借支数目") {
							item.IsShow = true;
						}
						if (item.Property.Title[0].Text == "流程编号") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "附件") {
							item.IsShow = true;
						}
						if (item.Property.Title[0].Text == "大写金额") {
							item.Disable = true;
							item.IsShow = true;
						}
					});
					this.templateData = this.assignControl(controls, this.logInfo);
					this.templateData = await this.assignControlBySpNo(controls, this.spNo);
					this.templateData.TemplateContent.Controls.forEach(e => {
						if (e.Property.Title[0].Text == '费用承担部门' && e.Value != null) {
							e.IsShow = true;
						}
					})
					this.listLoading = false;
					console.log(controls)
				});
			},
			getEmployeeRelation: async function(empNo) {
				await getRelation(empNo).then(response => {
					this.relationList = response.Body[0].Nodes;
				});
			},
			getTextVal() {},
			getNumVal(number, name) {
				if (name == "借支数目") {
					var controls = this.templateData.TemplateContent.Controls;
					var controlInfo = controls.filter(item => item.Property.Title[0].Text == "大写金额")[0];
					var ret = "";
					if (number != "" && number != null && number != "0") {
						var unit = "仟佰拾亿仟佰拾万仟佰拾元角分",
							str = "";
						number += "00";
						var point = number.indexOf(".");
						if (point >= 0) {
							number = number.substring(0, point) + number.substr(point + 1, 2);
						}
						unit = unit.substr(unit.length - number.length);
						for (var i = 0; i < number.length; i++) {
							str +=
								"零壹贰叁肆伍陆柒捌玖".charAt(number.charAt(i)) + unit.charAt(i);
						}
						ret =
							str
							.replace(/零(仟|佰|拾|角)/g, "零")
							.replace(/(零)+/g, "零")
							.replace(/零(万|亿|元)/g, "$1")
							.replace(/(亿)万|(拾)/g, "$1$2")
							.replace(/^元零?|零分/g, "")
							.replace(/元$/g, "元") + "整";
					}
					controlInfo.Value = ret;
				}
			},
			getSelectorVal(val, name) {
				if (name == "借支类型") {
					var isBusiness = true;
					var controls = this.templateData.TemplateContent.Controls;
					var controlInfo = controls.filter(item => item.Property.Title[0].Text == name)[0];
					var option = controlInfo.Config.Selector.Options
						.filter(item => {
							return item.Key == val;
						})[0];
					var departName = this.logInfo.fullName;
					var departs = this.logInfo.fullName.split("/");
					if (option.Value[0].Text == "非营业借支") {
						isBusiness = false;
					}
					if (isBusiness) {
						var businessControl = controls.filter(item => item.Property.Title[0].Text == "选择对应部门")[0];
						businessControl.Disable = false;
						if (departs.indexOf("住宅部") > -1) {
							businessControl.Value = businessControl.Config.Selector.Options.filter(t => {
								return t.Value[0].Text == "住宅部"
							})[0].Key;
							businessControl.Disable = true;
						}
						if (departs.indexOf("工商铺商业运营中心") > -1) {
							businessControl.Value = businessControl.Config.Selector.Options.filter(t => {
								return t.Value[0].Text == "工商铺部"
							})[0].Key;
							businessControl.Disable = true;
						}
						if (departs.indexOf("二级市场营运中心") > -1 || departs.indexOf("代理") > -1) {
							businessControl.Value = businessControl.Config.Selector.Options.filter(t => {
								return t.Value[0].Text == "代理/二级市场"
							})[0].Key;
							businessControl.Disable = true;
						}
						if (departs.indexOf("房友圈") > -1) {
							businessControl.Value = businessControl.Config.Selector.Options.filter(t => {
								return t.Value[0].Text == "房友圈"
							})[0].Key;
							businessControl.Disable = true;
						}
						if (departs.indexOf("按揭金融服务中心") > -1) {
							businessControl.Value = businessControl.Config.Selector.Options.filter(t => {
								return t.Value[0].Text == "汇瀚"
							})[0].Key;
							businessControl.Disable = true;
						}
					}


					var businessControl = controls.filter(item => item.Property.Title[0].Text == "选择对应部门")[0];
					var noBusinessControl = controls.filter(item => item.Property.Title[0].Text == "费用承担部门")[0];
					businessControl.IsShow = isBusiness;
					businessControl.Property.Require = isBusiness ? 1 : 0;
					noBusinessControl.Property.Require = !isBusiness ? 1 : 0;
					noBusinessControl.IsShow = !isBusiness;
					controls.filter(item => item.Property.Title[0].Text == "营业部合同审批工作流水水号")[0].IsShow = !isBusiness;

				}
				if (name == "选择对应部门") {
					var controls = this.templateData.TemplateContent.Controls;
					var controlInfo = controls.filter(item => item.Property.Title[0].Text == name)[0];
					var option = controlInfo.Config.Selector.Options
						.filter(item => {
							return item.Key == val;
						})[0];
					var departName = this.logInfo.fullName;
					var controlDepart = controls.filter(item => item.Property.Title[0].Text == "部门负责人")[0];
					if (option.Value[0].Text == "住宅部") {
						controlDepart.Values = [];
						controlDepart.Values.push(this.$store.state.defaultMember);
					}
					if (option.Value[0].Text == "工商铺部") {
						controlDepart.Values = [
              ["SC16006360","覃斌"]
						]
					}
					if (option.Value[0].Text == "代理/二级市场") {
						controlDepart.Values = [
							["SC23000441", "陈相云"]
						]
					}
					if (option.Value[0].Text == "房友圈") {
						controlDepart.Values = [
							["SC24000022", "汪净"]
						]
					}
					if (option.Value[0].Text == "汇瀚") {
						controlDepart.Values = [
							["SC04110010", "杨小玉"]
						]
					}


				}
				if (name == "费用承担部门") {
					var controls = this.templateData.TemplateContent.Controls;
					var controlInfo = controls.filter(item => item.Property.Title[0].Text == name)[0];
					controls.forEach(item => {

						if (item.Property.Title[0].Text == "住宅部") {
							item.IsShow = false;
							item.Property.Require = 0;
						}
						if (item.Property.Title[0].Text == "二级市场") {
							item.IsShow = false;
							item.Property.Require = 0;
						}
						if (item.Property.Title[0].Text == "代理") {
							item.IsShow = false;
							item.Property.Require = 0;
						}
						if (item.Property.Title[0].Text == "非营业部") {
							item.IsShow = false;
							item.Property.Require = 0;
						}

					})
					var option = controlInfo.Config.Selector.Options
						.filter(item => {
							return item.Key == val;
						})[0];

					var control = controls.filter(item => item.Property.Title[0].Text == option.Value[0].Text)[0];
					if (control != null) {
						control.IsShow = true;
						control.Property.Require = 1;
					}
				}
				if (name == "借款类型") {
					var isOther = true;
					var controls = this.templateData.TemplateContent.Controls;
					var controlInfo = controls.filter(item => item.Property.Title[0].Text == name)[0];
					var option = controlInfo.Config.Selector.Options
						.filter(item => {
							return item.Key == val;
						})[0];
					if (option.Value[0].Text == "备用金") {
						isOther = false;
					}
					var otherControl = controls.filter(item => item.Property.Title[0].Text == "其他临时借款")[0];
					var noOtherControl = controls.filter(item => item.Property.Title[0].Text == "备用金")[0];
					otherControl.IsShow = isOther;
					otherControl.Property.Require = isOther ? 1 : 0;
					noOtherControl.Property.Require = !isOther ? 1 : 0;
					noOtherControl.IsShow = !isOther;
				}
				this.$forceUpdate()
			},
			tableOperation(val, type, datas) {
				this.tableoperation(val, type, datas, this);
			},
			submit() {
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					return;
				}

				var SummaryList = [];
				var info = {
					SummaryInfo: []
				}
				info.SummaryInfo = [];

				var control = this.templateData.TemplateContent.Controls.filter(t => {
					return t.Property.Title[0].Text == "费用承担部门"
				})[0]
				var info = {
					SummaryInfo: []
				}
				info.SummaryInfo = [];
				var NameOfData = "";
				for (var i = 0; i < control.Config.Selector.Options.length; i++) {
					var data = control.Config.Selector.Options[i];
					if (data.Key == control.Value) {
						NameOfData = data.Value[0].Text;
					}
				}
				info.SummaryInfo.push({
					"Text": "费用承担部门：" + NameOfData,
					"Lang": "zh_CN"
				});
				SummaryList.push(info);


				var control2 = this.templateData.TemplateContent.Controls.filter(t => {
					return t.Property.Title[0].Text == "借款类型"
				})[0]
				var info = {
					SummaryInfo: []
				}
				info.SummaryInfo = [];
				var NameOfData = "";
				for (var i = 0; i < control2.Config.Selector.Options.length; i++) {
					var data = control2.Config.Selector.Options[i];
					if (data.Key == control2.Value) {
						NameOfData = data.Value[0].Text;
					}
				}
				info.SummaryInfo.push({
					"Text": "借款类型：" + NameOfData,
					"Lang": "zh_CN"
				});
				SummaryList.push(info);

				var control3 = this.templateData.TemplateContent.Controls.filter(t => {
					return t.Property.Title[0].Text == "借支数目"
				})[0]
				var info = {
					SummaryInfo: []
				}
				info.SummaryInfo = [];
				info.SummaryInfo.push({
					"Text": "借支数目：" + control3.Value,
					"Lang": "zh_CN"
				});
				SummaryList.push(info);

				this.templateData.SummaryList = SummaryList;

				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
					return;
				}



				var selectText = "";
				var control1 = this.templateData.TemplateContent.Controls.filter(t => {
					return t.Property.Title[0].Text == "费用承担部门"
				})[0]
				if (control1.IsShow == 1) {
					selectText = control1.Config.Selector.Options.filter(t => {
						return t.Key == control1.Value
					})[0].Value[0].Text;
				} else {
					var control2 = this.templateData.TemplateContent.Controls.filter(t => {
						return t.Property.Title[0].Text == "选择对应部门"
					})[0]
					selectText = control2.Config.Selector.Options.filter(t => {
						return t.Key == control2.Value
					})[0].Value[0].Text;
				}
				var SummaryList = [];
				var info = {
					SummaryInfo: []
				}
				info.SummaryInfo = [];
				info.SummaryInfo.push({
					"Text": "费用承担部门：" + selectText,
					"Lang": "zh_CN"
				});
				SummaryList.push(info);

				var control3 = this.templateData.TemplateContent.Controls.filter(t => {
					return t.Property.Title[0].Text == "借款类型"
				})[0]
				var control3Text = control3.Config.Selector.Options.filter(t => {
					return t.Key == control3.Value
				})[0].Value[0].Text;
				var info = {
					SummaryInfo: []
				}
				info.SummaryInfo = [];
				info.SummaryInfo.push({
					"Text": "借款类型：" + control3Text,
					"Lang": "zh_CN"
				});
				SummaryList.push(info);

				var control4 = this.templateData.TemplateContent.Controls.filter(t => {
					return t.Property.Title[0].Text == "借支数目"
				})[0]
				var info = {
					SummaryInfo: []
				}
				info.SummaryInfo = [];
				info.SummaryInfo.push({
					"Text": "借支数目：" + control4.Value,
					"Lang": "zh_CN"
				});
				SummaryList.push(info);


				this.templateData.SummaryList = SummaryList

				isSubmit = true;
				this.formLoading = true;
				//费用承担部门
				//借款类型
				//借支数目
				//提交
				submitProcess(this.templateId, this.logInfo.EmpNo, this.spNo, this.templateData).then(response => {
					this.Message({
						message: '申请成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/index");
					}, 3000)
				}).finally(() => {
					isSubmit = false;
					this.formLoading = false;
				});
			}
		},

	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
